import { tenantScopedStorageKey } from '@/utils/tenantScopedKeys'

export const DASHBOARD_TABS = ['summary', 'analysis'] as const
export type DashboardTab = (typeof DASHBOARD_TABS)[number]

export const DASHBOARD_TAB_LABELS: Record<DashboardTab, string> = {
  summary: 'Resumen',
  analysis: 'Análisis',
}

const STORAGE_BASE = 'dashboard-active-tab'

/** Preferencia por negocio; si el almacenamiento no está disponible, Resumen. */
export function readDashboardTab(tenantId: string | null): DashboardTab {
  try {
    return localStorage.getItem(tenantScopedStorageKey(STORAGE_BASE, tenantId)) === 'analysis'
      ? 'analysis'
      : 'summary'
  } catch {
    return 'summary'
  }
}

export function saveDashboardTab(tenantId: string | null, tab: DashboardTab): void {
  try {
    localStorage.setItem(tenantScopedStorageKey(STORAGE_BASE, tenantId), tab)
  } catch {
    /* almacenamiento no disponible */
  }
}

/** Navegación por teclado del tablist (flechas, Home y End). */
export function dashboardTabFromKey(
  current: DashboardTab,
  key: string
): DashboardTab | null {
  if (key === 'Home') return DASHBOARD_TABS[0]
  if (key === 'End') return DASHBOARD_TABS[DASHBOARD_TABS.length - 1]
  if (key !== 'ArrowRight' && key !== 'ArrowLeft') return null

  const index = DASHBOARD_TABS.indexOf(current)
  const delta = key === 'ArrowRight' ? 1 : -1
  return DASHBOARD_TABS[(index + delta + DASHBOARD_TABS.length) % DASHBOARD_TABS.length]
}
